/**
 * Boost banner tiles (AQ-1063) come with an auto-generated redirect URL.
 * Tiles used purely for informational content (e.g. Afterpay messaging)
 * should not be clickable, so we gate on whether the URL points on-site.
 *
 * On-site is determined by a simple substring check against the storefront
 * domain — good enough for absolute Boost-generated URLs and avoids parsing
 * edge cases (protocol-relative, missing scheme, etc).
 */
const ON_SITE_DOMAIN = 'aquila.com.au';
export function isOnSiteUrl(url) {
    if (!url)
        return false;
    return url.includes(ON_SITE_DOMAIN);
}
